import React, { useEffect } from "react";
import { useState } from "react";
import { useLocation } from "react-router";
import BoxShadow from "../../../../../Common/Components/BoxShadow";
import { Step, StepLabel, Stepper } from "@mui/material";
import OptionAndDate from "./Components/OptionAndDate";
import SelectType from "./Components/SelectType";
import SetTimes from "./Components/SetTimes";
import SubmitTimes from "./Components/SubmitTimes";
import { useParams } from "react-router-dom";
import { Get } from "../../../../../../Request";
import {
  BsArrowLeftCircleFill,
  BsFillArrowRightCircleFill,
} from "react-icons/bs";
import toast from "react-hot-toast";
function Index() {
  const { slug } = useParams();
  const [form, setForm] = useState({
    step: 0,
    ballprice: false,
    child: false,
    option: {
      needtitle: false,
      needcapacity: false,
      needgender: false,
      needsession: false,
      needdate: false,
      needballprice: false,
      needchild: false,
    },
    times: [],
  });
  useEffect(() => {
    if (slug) {
      if (slug.split("-").length > 1) {
        setForm({
          ...form,
          item_id: slug.split("-")[0],
          action: slug.split("-")[1],
        });
      } else {
        setForm({
          ...form,
          item_id: slug.split("-")[0],
        });
      }
    }
  }, []);
  const getTemplate = async () => {
    // const data = await Get({
    //   url: "/timetable/createweek",
    //   data: form,
    // });
    Get({
      url: "/timetable/createweek",
      data: form,
    }).then(res => {
      if (res) {
        setForm({
          ...form,
          times: res,
          keys: Object.keys(res),
          weekTimes: true,
        });
      }
    });
  };
  const steps = [
    {
      name: "انتخاب امکانات و ثبت تاریخ قرارداد",
      id: 1,
    },
    {
      name: "انتخاب نوع استفاده تاریخ",
      id: 2,
    },
    {
      name: "ثبت زمان بندی",
      id: 3,
    },
    {
      name: "تایید نهایی",
      id: 4,
    },
  ];
  const inputs = [
    {
      type: "needtitle",
      input: "text",
      key: "title",
      label: "عنوان",
    },

    {
      type: "needgender",
      input: "select",
      key: "gender",
      label: "جنسیت",
    },

    {
      type: "needcapacity",
      input: "number",
      key: "capacity",
      label: "ظرفیت",
    },
    {
      type: "needsession",
      input: "number",
      key: "session",
      label: "تعداد جلسات",
    },
    {
      type: "default",
      input: "time",
      key: "start",
      label: "شروع",
    },
    {
      type: "default",
      input: "time",
      key: "end",
      label: "پایان",
    },
    {
      type: "default",
      input: "number",
      key: "buyprice",
      label: form.option.needchild ? "قیمت خرید بزرگسال" : "قیمت خرید",
    },
    {
      type: "default",
      input: "number",
      key: "price",
      label: form.option.needchild ? "قیمت فروش بزرگسال" : "قیمت فروش",
    },
    {
      type: "default",
      input: "number",
      key: "boxofficeprice",
      label: form.option.needchild ? "قیمت گیشه بزرگسال" : "قیمت گیشه ",
    },
    {
      type: "needchild",
      input: "number",
      key: "buychildprice",
      label: "قیمت خرید خردسال",
    },
    {
      type: "needchild",
      input: "number",
      key: "childprice",
      label: "قیمت فروش خردسال",
    },
    {
      type: "needchild",
      input: "number",
      key: "boxofficechildprice",
      label: "قیمت گیشه خردسال",
    },
  ];
  const renderComponent = () => {
    switch (form.step) {
      case 0:
        return <OptionAndDate form={form} setForm={setForm} />;
      case 1:
        return <SelectType form={form} setForm={setForm} />;
      case 2:
        return (
          <SetTimes
            inputs={inputs}
            form={form}
            getTemplate={getTemplate}
            setForm={setForm}
          />
        );
      case 3:
        return <SubmitTimes inputs={inputs} form={form} setForm={setForm} />;
      default:
        break;
    }
  };
  const validateStep = () => {
    let res = { status: true };
    switch (form.step) {
      case 0:
        if (!form.date_start && !form.date_end) {
          res = { status: false };
          toast.error("تاریخ شروع و پایان وارد نشده است");
        }
        if (form.option.needballprice) {
          if (form.ballprice == false || form.ballprice == "" || form.ballprice == null) {
            res = { status: false };
            toast.error("قیمت اجاره توپ را وارد نمائید");
          }
        }
        if (form.option.needchild) {
          if (form.child == false || form.child == "" || form.child == null) {
            res = { status: false };
            toast.error("توضیحات خردسال را وارد نمائید");
          }
        }
        return res;
      case 1:
        if (form.show_model) {
          res = { status: true };
        } else {
          res = { status: false };
          toast.error("لطفا نوع زمان بندی را انتخاب کنید");
        }
        return res;
      case 2:
        return {
          status: true,
        };
        break;
      case 3:
        return {
          status: true,
        };
        break;

      default:
        break;
    }
  };
  return (
    <>
      <BoxShadow
        style={{
          padding: "10px",
        }}
      >
        <Stepper activeStep={form.step}>
          {steps.map((step, index) => {
            return (
              <Step key={step.id}>
                <StepLabel>{step.name}</StepLabel>
              </Step>
            );
          })}
        </Stepper>
      </BoxShadow>

      {renderComponent()}

      <div className="row justify-content-between mt-3">
        {form.step > 0 && (
          <div className="col-2">
            <button
              style={{
                backgroundColor: "transparent",
                border: "none",
                color: "#1976d2",
              }}
              onClick={() => {
                if (form.step == 2 && !form.option.needdate) {
                  setForm({ ...form, step: form.step - 2 });
                } else {
                  setForm({ ...form, step: form.step - 1 });
                }
              }}
            >
              <BsFillArrowRightCircleFill size={30} />
            </button>
          </div>
        )}
        {form.step !== 3 && (
          <div
            className={` ${form.step > 0 ? "col-2" : "col-12"
              }  d-flex justify-content-end`}
          >
            <button
              style={{
                backgroundColor: "transparent",
                border: "none",
                color: "#1976d2",
              }}
              onClick={() => {
                if (form.step === 0 && !form.option.needdate) {
                  validateStep()["status"] && setForm({ ...form, step: 2 });
                } else {
                  validateStep()["status"] &&
                    setForm({ ...form, step: form.step + 1 });
                }
              }}
            >
              <BsArrowLeftCircleFill size={30} />
            </button>
          </div>
        )}
      </div>
      {/* </BoxShadow> */}
    </>
  );
}
export default Index;
